import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { ID } from '@state/base';
import { InlineSvgDirective } from '@directives/inline-svg';
import { ClientNotificationsRepository, ClientNotificationsService } from '@state/client-notifications';

@Component({
  encapsulation: ViewEncapsulation.None,
  imports: [AsyncPipe, InlineSvgDirective],
  selector: 'fl-client-notifications-banner',
  styleUrls: ['./client-notifications-banner.component.scss'],
  templateUrl: './client-notifications-banner.component.html'
})
export class ClientNotificationsBannerComponent implements OnInit {
  private clientNotificationsRepository = inject(ClientNotificationsRepository);
  private clientNotificationsService = inject(ClientNotificationsService);

  notifications$ = this.clientNotificationsRepository.activeClientNotifications$;

  ngOnInit(): void {}

  dismiss(id: ID): void {
    this.clientNotificationsService.dismissNotification(id);
  }
}
